import { getLogger, type Logger } from '@logtape/logtape'

const cache = new Map<string, Logger>()

export function useLogger(appPrefix: string, category: string): Logger {
  const key = `${appPrefix}.${category}`
  if (!cache.has(key)) {
    cache.set(key, getLogger([appPrefix, category]))
  }
  return cache.get(key)!
}
